import { type IExternalWagerService, type IGetExternalWagerUseCase, NotFoundError } from '../../../domain/entry.js';

/**
 * Use case for getting an external wager containing a coupon.
 *
 * @param externalWagerService External wager service dependency
 * @returns Use case executor for getting external wager
 */
export function getExternalWagerUseCase(externalWagerService: IExternalWagerService): IGetExternalWagerUseCase {
  return {
    execute: async ({ externalWagerGuid }): ReturnType<IGetExternalWagerUseCase['execute']> => {
      const wager = await externalWagerService.getExternalWagerAsync(externalWagerGuid);

      if (!wager) {
        throw new NotFoundError(`External wager with guid: ${externalWagerGuid} not found`);
      }

      return wager;
    },
  };
}
